import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { BASE_API_URL } from "../../../../../config";

export interface Location {
  lat: number;
  lng: number;
}
interface AddLocatioinSeacrhProps {
  name: string;
  title: string;
  note: string;
  placeholder: string;
  index: number;
  isVisible: boolean;
  value: string;
  onChange: (address: string, title: string, link: string, location: Location) => void;
}

const AddLocatioinSeacrh: React.FC<AddLocatioinSeacrhProps> = ({ name, title, note, placeholder, index, isVisible, value, onChange }) => {
  const [searchTerm, setSearchTerm] = useState(value);
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const { isEditable } = useContext(CreateArtifactContext);

  useEffect(() => {
    const fetchPlaces = async () => {
      if (isEditable) {
        if (searchTerm && searchTerm.length > 3) {
          try {
            //https://us-central1-skarvostore.cloudfunctions.net/
            const response = await axios.get(`${BASE_API_URL}/placeAutocomplete`, {
              params: { inputText: searchTerm },
            });

            if (response.data && response.data.predictions) {
              setSuggestions(response.data.predictions);
            }
          } catch (error) {
            console.error("Error fetching places:", error);
          }
        } else {
          setSuggestions([]);
        }
      }
    };

    const debounceFetch = setTimeout(fetchPlaces, 300);
    return () => clearTimeout(debounceFetch);
  }, [searchTerm, isEditable]);

  const handleSelect = async (placeId: string) => {
    try {
      //https://us-central1-skarvostore.cloudfunctions.net/
      const response = await axios.get(`${BASE_API_URL}/placeDetails`, {
        params: { place_id: placeId },
      });

      const placeDetails = response.data.result;
      if (placeDetails) {
        const address = placeDetails.formatted_address;
        const title = placeDetails.name;
        const location = placeDetails.geometry.location;
        const link = placeDetails.website; // `https://www.google.com/maps/place/?q=place_id:${placeId}`;

        //alert(`Clicked Me: ${title}`);
        setSearchTerm("");
        setSuggestions([]);
        onChange(address, title, link, location);
        setSearchTerm("");
        setSuggestions([]);
      }
    } catch (error) {
      console.error("Error fetching place details:", error);
    }
  };

  return (
    <div className="relative w-full min-w-[200px]">
      {isVisible && (
        <div className="flex items-center">
          <span>{index && <span className="content_count">{index}</span>}</span>
          {title && <span className="content_title">{title}</span>}
        </div>
      )}
      {note && <div className="notes-class-content">{note}</div>}
      <div className="flex input-class">
        <input
          id={name}
          type="text"
          name={name}
          className="input-text"
          placeholder={placeholder}
          required
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          onClick={() => setSearchTerm("")}
          disabled={!isEditable}
        />
      </div>
      {suggestions.length > 0 && (
        <div className="absolute z-10 bg-white border border-gray-300 rounded-lg shadow-lg max-w-[480px]">
          {suggestions.map(suggestion => (
            <div key={suggestion.place_id} onClick={() => handleSelect(suggestion.place_id)} className="p-2 cursor-pointer hover:bg-gray-200">
              {suggestion.description}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddLocatioinSeacrh;
